import Onboarding from "../pages/onboarding/Onboarding";
// import Login from '../pages/login/NewThemeLogin';
import Login from "../pages/login/NewThemeLoginv1";
import LanguageSelection from "../pages/language/NewThemeLanguages";
import Disclaimerpage from "../pages/template/disclaimerpage";
import NewLoginPage from "../pages/template/newLoginPage";
import NewLoginPageSec from "../pages/template/newLoginPageSec";
import NewLoginPageDesc from "../pages/template/newLoginPageDesc";
import NewSelectLanguagePage from "../pages/template/newSelectLanguagePage";
import NewHomePage from "../pages/template/newHomePage";
import Userselection from "../pages/home/Userselect";


import Registration from "../pages/registration/NewThemeRegistration";
// import ChatWindow from '../imon/components/Chat/ChatWindow';
// import Chat from '../imon/components/Chat/Chat';
const routes = [
  
  {
    path: "/onboarding",
    name: "Onboarding",
    displayName: "Onboarding",
    component: Onboarding,
  },
  {
    path: "/login",
    name: "Login",
    displayName: "Login",
    component: Login,
  },
  {
    path: "/selectlanguage",
    name: "selectlanguage",
    displayName: "selectlanguage",
    component: LanguageSelection,
  },
  {
    path: "/disclaimerpage",
    name: "disclaimerpage",
    displayName: "disclaimerpage",
    component: Disclaimerpage,
  },
  {
    path: "/template/newLoginPage",
    name: "newLoginPage",
    displayName: "newLoginPage",
    component: NewLoginPage,
  },
  {
    path: "/template/newLoginPageSec",
    name: "newLoginPageSec",
    displayName: "newLoginPageSec",
    component: NewLoginPageSec,
  },
  {
    path: "/template/newLoginPageDesc",
    name: "newLoginPageDesc",
    displayName: "newLoginPageDesc",
    component: NewLoginPageDesc,
  },

  {
    path: "/template/newSelectLanguagePage",
    name: "newSelectLanguagePage",
    displayName: "newSelectLanguagePage",
    component: NewSelectLanguagePage,
  },
  {
    path: "/template/newhomepage",
    name: "newHomePage",
    displayName: "newHomePage",
    component: NewHomePage,
  },
  {
    redirect: true,
    path: "/",
    to: "/login",
    // name: "Login"

    //default: "/",
    name: "Onboarding",
    displayName: "Onboarding",
    component: Onboarding,
  },
];

export default routes;
